"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const jsxRuntime = require("react/jsx-runtime");
const clsx = require("../../../chunks/clsx-CBkIpawf.js");
const components_utility_spacing_spacing = require("../../../components/utility/spacing/spacing.js");
const underline = "_underline_3kw2f_13";
const heading = "_heading_3kw2f_17";
const text = "_text_3kw2f_1";
const price = "_price_3kw2f_219";
const styles = {
  "text-align-left": "_text-align-left_3kw2f_1",
  "text-align-center": "_text-align-center_3kw2f_5",
  "text-align-right": "_text-align-right_3kw2f_9",
  underline,
  heading,
  "heading-display": "_heading-display_3kw2f_22",
  "heading-largest": "_heading-largest_3kw2f_46",
  "heading-large": "_heading-large_3kw2f_46",
  "heading-medium": "_heading-medium_3kw2f_94",
  "heading-small": "_heading-small_3kw2f_118",
  "heading-smallest": "_heading-smallest_3kw2f_142",
  "heading-tiny": "_heading-tiny_3kw2f_166",
  text,
  "text-body": "_text-body_3kw2f_195",
  "text-body-head": "_text-body-head_3kw2f_201",
  "text-caption": "_text-caption_3kw2f_207",
  "text-caption-head": "_text-caption-head_3kw2f_213",
  price,
  "price-large": "_price-large_3kw2f_224",
  "price-large-discount": "_price-large-discount_3kw2f_230",
  "price-medium": "_price-medium_3kw2f_237",
  "price-medium-discount": "_price-medium-discount_3kw2f_243",
  "price-small": "_price-small_3kw2f_250",
  "price-small-discount": "_price-small-discount_3kw2f_256"
};
const deprecatedVariantsMap = {
  large: "heading-largest",
  medium: "heading-large",
  small: "heading-medium",
  smallest: "heading-small",
  subheading1: "heading-smallest",
  subheading2: "heading-tiny",
  body: "text-body",
  "body-head": "text-body-head",
  caption: "text-caption",
  "caption-head": "text-caption-head"
};
const classMap = {
  heading: styles.heading,
  text: styles.text,
  price: styles.price
};
const Text = ({
  component,
  align,
  underline: underline2,
  children,
  variant = "text-body",
  spacings,
  ...props
}) => {
  const Component = component || "p";
  let textStyleClasses;
  if (variant in deprecatedVariantsMap) {
    variant = deprecatedVariantsMap[variant];
  }
  const variantType = variant.split("-")[0];
  textStyleClasses = classMap[variantType] || "";
  const className = clsx.clsx(
    textStyleClasses,
    spacings && components_utility_spacing_spacing.spacingHelper(spacings),
    styles[align ? `text-align-${align}` : ""],
    styles[underline2 ? "underline" : ""],
    styles[variant],
    props.className
  );
  return /* @__PURE__ */ jsxRuntime.jsx(Component, { ...props, className, children });
};
const H1 = ({ variant = "heading-largest", ...props }) => /* @__PURE__ */ jsxRuntime.jsx(Text, { variant, component: "h1", ...props, children: props.children });
const H2 = ({ variant = "heading-large", ...props }) => /* @__PURE__ */ jsxRuntime.jsx(Text, { variant, component: "h2", ...props, children: props.children });
const H3 = ({ variant = "heading-medium", ...props }) => /* @__PURE__ */ jsxRuntime.jsx(Text, { variant, component: "h3", ...props, children: props.children });
const H4 = ({ variant = "heading-small", ...props }) => /* @__PURE__ */ jsxRuntime.jsx(Text, { variant, component: "h4", ...props, children: props.children });
const H5 = ({ variant = "heading-smallest", ...props }) => /* @__PURE__ */ jsxRuntime.jsx(Text, { variant, component: "h5", ...props, children: props.children });
const H6 = ({ variant = "heading-tiny", ...props }) => /* @__PURE__ */ jsxRuntime.jsx(Text, { variant, component: "h6", ...props, children: props.children });
const P = ({ variant = "text-body", ...props }) => /* @__PURE__ */ jsxRuntime.jsx(Text, { variant, component: "p", ...props, children: props.children });
const Strong = ({
  variant = "text-body-head",
  ...props
}) => /* @__PURE__ */ jsxRuntime.jsx(Text, { variant, component: "strong", ...props, children: props.children });
const Small = ({ variant = "text-caption", ...props }) => /* @__PURE__ */ jsxRuntime.jsx(Text, { variant, component: "small", ...props, children: props.children });
const Figcaption = ({
  variant = "text-caption",
  ...props
}) => /* @__PURE__ */ jsxRuntime.jsx(Text, { variant, component: "figcaption", ...props, children: props.children });
exports.Figcaption = Figcaption;
exports.H1 = H1;
exports.H2 = H2;
exports.H3 = H3;
exports.H4 = H4;
exports.H5 = H5;
exports.H6 = H6;
exports.P = P;
exports.Small = Small;
exports.Strong = Strong;
exports.Text = Text;
exports.deprecatedVariantsMap = deprecatedVariantsMap;
